import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import { gsap } from "gsap";

export const LineChartUp = ({ className }: { className?: string }) => {
  const lineRef = useRef<SVGPolygonElement>(null);
  const arrowRef = useRef<SVGPolygonElement>(null);

  useGSAP(() => {
    const line = lineRef.current;
    const arrow = arrowRef.current;

    if (!line || !arrow) return;

    // Create infinite loop timeline
    const tl = gsap.timeline({ repeat: -1, repeatDelay: 1 });

    // Initially hide the line and arrow
    gsap.set([line, arrow], {
      opacity: 0,
    });

    // Animate line drawing from left to right
    tl.fromTo(
      line,
      {
        clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
        opacity: 1,
      },
      {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        duration: 2.5,
        ease: "power2.out",
      }
    )
      // Fade in arrow after line is drawn
      .fromTo(
        arrow,
        {
          opacity: 0,
          scale: 0.5,
          transformOrigin: "center center",
        },
        {
          opacity: 1,
          scale: 1,
          duration: 0.5,
          ease: "back.out(2)",
        },
        "-=0.3"
      )
      // Hold for a moment
      .to({}, { duration: 1 })
      // Reset for next loop
      .set([line, arrow], { opacity: 0 })
      .set(line, { clipPath: "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)" })
      .set(arrow, { scale: 0.5 });
  });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 200 200"
      height={150}
      width={150}
      className={className}
    >
      <defs>
        <linearGradient
          id="line-chart-up-gradient"
          x1="91.2"
          y1="32.2"
          x2="103"
          y2="178.5"
          gradientTransform="translate(0 202) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#52b773" />
          <stop offset="1" stopColor="#43b0da" />
        </linearGradient>
        <linearGradient
          id="line-chart-up-gradient-arrow"
          x1="163.5"
          y1="26.4"
          x2="175.3"
          y2="172.6"
          gradientTransform="translate(0 202) scale(1 -1)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#52b773" />
          <stop offset="1" stopColor="#43b0da" />
        </linearGradient>
      </defs>
      <polygon
        ref={lineRef}
        fill="url(#line-chart-up-gradient)"
        points="17.7 184.9 12.7 182.2 39 132.7 52.3 146.9 72.1 104.7 85.6 122.3 109.4 66.8 124.8 87.6 142.7 44 152.4 63.7 175.7 18.2 180.8 20.9 152.2 76.5 143.1 58 126.2 99.2 110.8 78.3 87 133.5 73.3 115.7 53.9 157 40.3 142.5 17.7 184.9"
      />
      <polygon
        ref={arrowRef}
        fill="url(#line-chart-up-gradient-arrow)"
        points="182.4 33.3 178.2 19.9 165 23.3 163.6 17.7 182.1 13 187.8 31.6 182.4 33.3"
      />
    </svg>
  );
};
